import { useDispatch, useSelector } from 'react-redux'
import { useMemo } from 'react'

import ApiPagination from 'components/ApiPagination'

import {
  getOrdersApiParamsConfig,
  getAllOrdersTotalCount,
} from 'store/Orders/selector'
import { setOrdersApiParamsConfig } from 'store/Orders/actions'
import { fetchAllOrders } from 'store/Orders/actions'

const OrdersPagination = () => {
  const dispatch = useDispatch()

  const ordersApiParamsConfig = useSelector(getOrdersApiParamsConfig)
  const totalOrdersCount = useSelector(getAllOrdersTotalCount)

  const { per, page } = ordersApiParamsConfig

  const currentPage = page
  const rowsPerPage = per

  const totalPages = useMemo(() => {
    return Math.ceil(totalOrdersCount / rowsPerPage)
  }, [totalOrdersCount, rowsPerPage])

  const handleChangeRowsPerPage = (event) => {
    const perPageCount = event.target.value

    const updatedParams = {
      ...ordersApiParamsConfig,
      per: Number(perPageCount),
      page: 1,
    }

    // update ordersApiParamsConfig
    dispatch(setOrdersApiParamsConfig(updatedParams))

    // fetch orders with new params
    dispatch(fetchAllOrders(updatedParams))
  }

  const handleClickPage = (page) => {
    // update ordersApiParamsConfig
    dispatch(
      setOrdersApiParamsConfig({
        ...ordersApiParamsConfig,
        page: page,
      })
    )

    // fetch orders with new param
    dispatch(
      fetchAllOrders({
        ...ordersApiParamsConfig,
        page: page,
      })
    )
  }

  return (
    <footer className="items__footer">
      <ApiPagination
        totalItemsCount={totalOrdersCount}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleClickPage={handleClickPage}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
      />
    </footer>
  )
}

export default OrdersPagination
